function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  fill: "transparent",
  cx: 10,
  cy: 12,
  r: 3
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 14c-.64 0-1.23.204-1.716.546l-1.56-1.114c.172-.447.276-.926.276-1.432 0-1.858-1.28-3.41-3-3.858V5.816C12.162 5.4 13 4.302 13 3c0-1.654-1.346-3-3-3S7 1.346 7 3c0 1.302.838 2.4 2 2.815v2.327c-1.72.447-3 2-3 3.858 0 .506.104.985.276 1.432l-1.56 1.114C4.23 14.204 3.64 14 3 14c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3c0-.287-.053-.56-.13-.822l1.576-1.125C8.14 15.635 9.024 16 10 16c.976 0 1.86-.365 2.554-.947l1.575 1.125c-.077.262-.13.535-.13.822 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3m0 4c-.55 0-1-.448-1-1s.45-1 1-1 1 .448 1 1-.45 1-1 1m-7-4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-7 4c-.55 0-1-.448-1-1s.45-1 1-1 1 .448 1 1-.45 1-1 1m7-16c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/asset-settings.66d90e0d.svg";
export { SvgComponent as ReactComponent };